module.exports = new __parcel__URL__("icon-default-grey.207d033d.png").toString();